<template>
  <RenderWithDependency
    :dependency="audioFile?.originalFileUrl"
    class="container xl:pr-220 paragraph--margin my-30"
  >
    <figure v-if="audioFile?.originalFileUrl">
      <!-- eslint-disable-next-line vuejs-accessibility/media-has-caption -->
      <audio controls :src="audioFile?.originalFileUrl" class="mb-10 w-full" />
      <figcaption v-if="figcaption">{{ figcaption }}</figcaption>
    </figure>
  </RenderWithDependency>
</template>

<script lang="ts" setup>
import type { ParagraphAudioPlayerFragment } from '#graphql-operations'

defineBlokkli({
  bundle: 'audio_player',
  globalOptions: ['bkVisibleLanguages'],
  chunkName: 'rare',
  editor: {
    editTitle: (el) => el.querySelector('figcaption')?.textContent,
  },
})

defineProps<{
  figcaption?: ParagraphAudioPlayerFragment['figcaption']
  audioFile?: ParagraphAudioPlayerFragment['audioFile']
}>()

defineOptions({
  name: 'ParagraphAudioPlayer',
})
</script>
